const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://v59t72qzmc.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://8iqwisj06b.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.us.forwood.one'
  },
  configurationService: {
    URL: 'https://config.us.forwood.one',
    WEBSOCKET: 'wss://worao5bibi.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
